module.exports = __webpack_public_path__ + "static/media/DashboardIllustration.245bfbb4.svg";